var _ = require('underscore');
var ModalDialogWidget = require('./../widget/modal/ModalDialogWidget');
var refundModalTemplate = require('./refundModalTemplate.hbs');
var RenderIfDisplayedBehavior = require('./../behaviors/RenderIfDisplayedBehavior');
var refundExtService = require('./../urls').refundExtService;

/**
 * Refund modal details shows the refund amount (not just static text).
 * @class RefundModalView
 * @constructor
 */
module.exports = ModalDialogWidget.extend({
  template: refundModalTemplate,

  behaviors: _.extend({
    renderIfDisplayed: RenderIfDisplayedBehavior
  }, ModalDialogWidget.prototype.behaviors),

  events: _.extend({}, ModalDialogWidget.prototype.events, {
    'click [data-close]': 'done'
  }),

  /**
   * @method initialize
   * @override
   * @param options {Object} the options of this view.
   *   @param options.refundAmount {Number} the amount being refunded.
   *   @param options.receiptMessageVecnaId {String} the vecna id of the receipt message being refunded.
   */
  initialize: function(options) {
    _.bindAll(this, '_refund', '_refundSuccess', '_refundFailure', '_completeProcessing');
    ModalDialogWidget.prototype.initialize.apply(this, arguments);
    this.reset(options.refundAmount);
    this._receiptMessageVecnaId = options.receiptMessageVecnaId;
    this._patientVecnaId = options.patientVecnaId;

    this.on('change:refundAmount change:processing change:completed', this._renderIfDisplayed);
  },

  /**
   * Override confirm to instead do the refund logic.
   * @method confirm
   */
  confirm: function() {
    this._refund();
  },

  /**
   * Resets the modal to a clean state so it can be shown again.
   * @method reset
   * @param refundAmount {Number} the amount being refunded.
   */
  reset: function(refundAmount) {
    this.set('processing', false);
    this.set('completed', false);
    this.set('success', false);
    this.setRefundAmount(refundAmount);
  },

  /**
   * @method setRefundAmount
   * @param refundAmount {Number} the amount being refunded.
   */
  setRefundAmount: function(refundAmount) {
    this.set('refundAmount', refundAmount);
  },

  /**
   * @method getRefundAmount
   * @return {Number} the amount being refunded.
   */
  getRefundAmount: function() {
    return this.get('refundAmount');
  },

  /**
   * Actually process the refund of the receipt.
   * @method _refund
   * @private
   */
  _refund: function() {
    this._startProcessing();
    // In the future this might change in the modal (partial refunds).
    var refundAmount = this.getRefundAmount();
    this._processRefund(refundAmount)
      .then(this._refundSuccess, this._refundFailure)
      .always(this._completeProcessing);
  },

  /**
   * Actually process the refund by talking to the server.
   * @method _processRefund
   * @param refundAmount {Number} the amount to refund.
   * @private
   */
  _processRefund: function(refundAmount) {
    return $.ajax({
      url: refundExtService,
      contentType: 'application/json',
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify({
        receiptMessageVecnaId: this._receiptMessageVecnaId,
        patientVecnaId: this._patientVecnaId,
        refundAmount: refundAmount
      })
    });
  },

  /**
   * @method _refundSuccess
   * @param response {Object} the response containing the refund result info.
   *   @param response.refundType {String} the type of refund that was issued.
   *   @param response.refundAmount {Number} the amount of refund issued.
   *   @param response.refundReceiptVecnaId {String} the vecnaId of the refund message that was created.
   * @private
   */
  _refundSuccess: function(response) {
    this.set('success', true);
    this.set('refundType', response.refundType);
    this.setRefundAmount(response.refundAmount);
    this.set('refundReceiptVecnaId', response.refundReceiptVecnaId);
  },

  /**
   * The refund failed to process.
   * @method _refundFailure
   * @param response {Object}
   *   @param response.responseJSON {Object} the error response body as a javascript object.
   *     @param response.responseJSON.error {String} the error code (either 'refund_failed' or not set)
   *     @param response.responseJSON.error_description {String} the type of refund that was issued.
   * @private
   */
  _refundFailure: function (response) {
    if (response && response.responseJSON) {
      this.set('refundErrorMessageKey', response.responseJSON.error_description);
    }
    this.set('success', false);
  },

  /**
   * @method _startProcessing
   * @private
   */
  _startProcessing: function() {
    this.viewState.unset('refundErrorMessageKey');
    this.set('processing', true);
  },

  /**
   * @method _completeProcessing
   * @private
   */
  _completeProcessing: function() {
    this.set('completed', true);
  },

  /**
   * This is a simple wrapper around this.resolveModal(), to clearly indicate a simple confirmation.
   *
   * @method done
   */
  done: function() {
    this.resolveModal();
  },

  /**
   * Renders the view only if it is active and part of the DOM.
   * @method _renderIfDisplayed
   * @private
   */
  _renderIfDisplayed: function() {
    if (this.isActive() && this.isAttached()) {
      this.render();
    }
  }
});
